import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/js/dist/modal'
import 'bootstrap/js/dist/collapse'
import i18n from './i18n'
import { ObserveVisibility } from 'vue-observe-visibility'

const app = createApp(App);
app.use(i18n);
app.directive('observe-visibility', ObserveVisibility)

app.mount('#app')
